
const state = {
  saldos: [], // array de saldos
  showSaldo: false,
  showRefresh: true
}


const mutations = {
  SET_SALDOS(state, saldos) {
    state.saldos = saldos
  },
  SET_SHOW_SALDO(state, show) {
    state.showSaldo = show
  }
}



const actions = {
  fetchSaldo({ commit, rootState }) {
    // Apenas controla permissão de exibição
    const perfil = localStorage.id_role
    if (perfil !== 4) {
      commit('SET_SHOW_SALDO', true)
    } else {
      commit('SET_SHOW_SALDO', false)
      commit('SET_SALDOS', [])
    }
  },
  updateSaldoViaWebSocket({ commit }, saldos) {
    commit('SET_SALDOS', saldos)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
